import { sectionEyebrow } from "../data/sections.js";

/* Section label: "(03) —— Case studies". The number follows the section's place in SECTIONS.
   Plain type and a hairline rule, matching the "(01)" chapter labels on the case study pages. */
export default function Eyebrow({ section, className = "" }) {
  const { number, label } = sectionEyebrow(section);
  return (
    <div className={`eye-brow${className ? ` ${className}` : ""}`}>
      <span className="eye-brow-number">({number})</span>
      <span className="eye-brow-rule" aria-hidden="true" />
      <span className="eye-brow-text">{label}</span>
    </div>
  );
}
